import {makeStyle} from '../../../utils';
import {
    blackHigh,
    blackMedium,
    blackOutline,
    bold,
    centerAbs,
    h5,
    overline, secondary, secondaryOutline, subTitle1, caption, button,
    subTitle2, horiCenterAbs, rowCenter, h6, black, body2
} from '../../../resources/styles';
import view from '../../../Enums';
const styles = {};

styles['title_slider_container'] = makeStyle({
    display:'flex',overflowX:'auto',height:'88px',border: `1px solid ${blackOutline.color}`
    ,position:'absolute',top:0,
    width:'100%',
    zIndex:'10',
    backgroundColor:'white'
},{},{},{height:'56px', padding:'16px 0px',justifyContent: 'center',borderTop:'',borderRight:'',borderLeft:''})

styles['page_container'] = makeStyle({
    position:'relative',paddingTop:'17px',paddingBottom:'30px',overflowY:'scroll'
},{
    paddingLeft:'32px',paddingRight:'32px',marginTop:'88px'
},view.DESKTOP,{
    paddingLeft:16,paddingRight:16,marginTop:'84px'
})

styles['state_button'] = makeStyle({
    display:'flex',flexDirection:'column',
    padding:'4px 8px',borderRadius: '4px',boxSizing: 'border-box',height:'fit-content',
    borderRadius:'4px',
    ...caption, letterSpacing:'0.2px',
},{},view.DESKTOP,{padding:'6px 8px'})

styles['tab_head_parent'] = makeStyle({display:'flex',position:'relative'})

styles['tab_back_child'] = makeStyle({...subTitle1,...blackHigh,color:'black'},{flex: '1 1 0'},view.DESKTOP)

styles['back'] = makeStyle({width:14,height:14,},{},view.DESKTOP)

styles['back_wrapper'] = makeStyle({marginRight:'11px'})

styles['tab_heading_container'] = makeStyle({},{...horiCenterAbs,textAlign:'center'},view.DESKTOP)

styles['tab_heading'] = makeStyle({},{...h5,letterSpacing: '-0.28px'},view.DESKTOP,{...subTitle1,...bold})

styles['tab_head_sub'] = makeStyle({...subTitle2,...blackMedium,marginTop:'8px',marginBottom:'36px'})

styles['tab_content_container'] = makeStyle({},{marginTop:'72px',marginBottom:'56px'},view.DESKTOP,{marginTop:'16px'})

styles['forward_container'] = makeStyle({flex: '1 1 0',textAlign:'right',textAlign:'-webkit-right'},{},view.DESKTOP)

styles['back_container'] = makeStyle({flex: '1 1 0'},{},view.DESKTOP)

styles['change_tab_back'] = makeStyle({
    border:`1px solid ${secondaryOutline.color}`
    ,padding:'8px 18px 8px 6px',borderRadius:'4px',width:'fit-content',height:'fit-content',
    ...secondary,...button})

styles['change_tab_forward'] = makeStyle({
    border:`1px solid ${secondaryOutline.color}`,
    padding:'8px 6px 8px 18px',borderRadius:'4px',width:'fit-content',height:'fit-content',
    ...secondary,...button})

styles['arrow_icon'] = makeStyle({...secondary,width:'24px',height:'12px'})

styles['footer'] = makeStyle({ width: '100%', zIndex: 100 });

styles['error_title'] = makeStyle([h5, { color: 'var(--theme-color)' }]);

styles['error_desc'] = makeStyle([subTitle1, rowCenter, { justifyContent: 'center', marginTop: 8 }]);

styles['error_action'] = makeStyle([h6, bold, secondary, { cursor: 'pointer' }]);

styles['dialog_header'] = makeStyle([rowCenter, {
    justifyContent: 'space-between', padding: '10px 10px 10px 22px'
}], { padding: '20px 20px 20px 32px' });

styles['dialog_title'] = makeStyle([h6, black, { letterSpacing: '-0.35px' }]);

styles['dialog_content'] = makeStyle([subTitle1, bold, { padding: '0 36px 32px 32px', color: '#035ed2', letterSpacing: '-0.35px' }]);

export default styles